import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNo',
})
export class YesNoPipe implements PipeTransform {
  transform(value: boolean, ..._args: unknown[]): string {
    return value ? 'YES' : 'NO';
  }
}
